import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Country } from 'src/app/shared/model/country';
import { PageRequest } from 'src/app/shared/model/page/page-request';
import { PageResult } from 'src/app/shared/model/page/page-result';
import { map } from 'rxjs/operators';
import { Courier } from 'src/app/shared/model/courier';
import { BaseFilter } from 'src/app/shared/model/filter/base-filter';
import { HttpUtils } from 'src/app/shared/services/common/http-utils';

@Injectable({
  providedIn: 'root',
})
export class CountryService {

  constructor(private readonly http: HttpClient) { }

  getCountries(): Observable<Country[]> {
    const httpParams = new HttpParams()
      .set('page', '0')
      .set('size', '10000');
    return this.http.get<PageResult<Country>>(`api/countries`, { params: httpParams }).pipe(map(page => page.content));
  }

  findAll(pageRequest: PageRequest): Observable<PageResult<Country>> {
    return this.http.get<PageResult<Country>>(`api/countries`, { params: pageRequest as any });
  }

  findByCode(countryCode: string): Observable<Country> {
    return this.http.get<Country>(`api/countries/${countryCode}`);
  }

}
